import { createSlice } from '@reduxjs/toolkit';
import { createCourse, ICourse } from '../../../models/courses';

interface ICourseState {
    courses: ICourse[],
    course: ICourse,
    isLoading: boolean,
};

const initialState: ICourseState = {
    courses: [],
    course: createCourse({}),
    isLoading: false,
};

export const coursesSlice = createSlice({
    name: 'courses',
    initialState,
    reducers: {
        setCourse: (state, action) => {
            state.isLoading = false;
            state.course = action.payload.course;
        },
        setCourses: (state, action) => {
            state.isLoading = false;
            state.courses = action.payload.courses;
        },
        startLoadingCourses: (state) => {
            state.isLoading = true;
        },
        updateCourses: (state, action) => {
            state.isLoading = false;

            const updated: ICourse[] = state.courses.map((item: ICourse) => {
                if (item.id === action.payload.course.id)
                    return action.payload.course;
                return item;
            });
            state.courses = updated;
        },
    }
});

// Action creators are generated for each case reducer function
export const {
    setCourse,
    setCourses,
    startLoadingCourses,
    updateCourses
} = coursesSlice.actions;